module.exports = "shipping: {{transactionShipping}},\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/Wizard/Snippet/snippets/transactionShipping.html
// module id = 2162
// module chunks = 0